import { useCampaignListingByType, ICampaignType } from '~/modules/campaign';

export const useCampaignUrlListing = () => useCampaignListingByType(ICampaignType.URL);
